module.exports = __webpack_public_path__ + "img/ic-tr-message.ddf7f0bf.svg";